import React, {useState} from "react";
import { Box, Button, Column, Columns, Title } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";
import usePostTarget from "../../hooks/usePostTarget";
import DepartmentSelector from "./Departments/DepartmentSelector";

function NewTarget({departments, loaded}) {
  let [weekly_target, amountInput] = useInput({
    type: "number",
    label: "Amount",
    currency: true
  });
  const [active_from, dateInput] = useInput({
    type: "date",
    label: "Active from"
  });
  let [active_to, activeToInput] = useInput({
    type: "date",
    label:
      "Active To (Leave blank if this is a new weekly target going forward)"
  });

  let [department, setDepartment] = useState("BLANK")

  active_to = active_to ? active_to : undefined;
  weekly_target = parseFloat(weekly_target);

  const onDepartmentChange = e => {
    setDepartment(departmentObjects[e.target.value]);
  }

  const [, postTarget] = usePostTarget({
    weekly_target,
    active_from,
    active_to,
    department
  });

  const handleSubmit = () => {
    postTarget();
  };

  const departmentObjects = loaded ? departments.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  return (
    <Box>
      <details>
        <summary><Title>Add Target</Title></summary>
      <Columns isMultiline>
        {dateInput}
        {activeToInput}
        {amountInput}
        <Column>
          <DepartmentSelector
            blank={true}
            editable={true}
            name={"department"}
            options={departments}
            label={"Department"}
            onChange={onDepartmentChange}
            value={department}
          />
        </Column>
      </Columns>

      <Columns isMultiline>
        <Column>
          <Button onClick={handleSubmit} color={"success"} isFullWidth>
            Add
          </Button>
        </Column>
      </Columns>
      </details>
    </Box>
  );
}

export default NewTarget;
